"use strict";

export const DEFAULT_TOUCH_SLOP = 15;
export const MINIMAL_RECOGNIZABLE_MAGNITUDE = 0.1;
export const NATIVE_GESTURE_ROLE_ATTRIBUTE = 'rngh-role';
//# sourceMappingURL=constants.js.map